export type pathByType = {
  [key: string]: string;
};

export const getPathByFocusType = (isWebview?: boolean) => {
  return '/pages' + (isWebview ? '/webview' : '');
};
